import React, { forwardRef } from 'react';
const ModalBody = (StyledModalBody) => forwardRef(({ children, ...props }, ref) => {
    return (<StyledModalBody ref={ref} {...props}>
        {children}
      </StyledModalBody>);
});
export default ModalBody;
